module.exports = __webpack_public_path__ + "img/logo-darkfans-white.341c04da.svg";